import { property } from 'lodash';
import axios from 'axios';

import {
  jsonApiHeaders,
  buildApiV2Url,
  toSurveyListSearchFilter,
  onlyCommonSurveysFilter,
} from '../utils/apiUtils';
import { mapSurveyNamesListFromApiModel } from '../dataMapper/surveyNamesListDataMapper';
import { generateApiError } from '../utils/apiErrorMessages';
import { SURVEY_TYPE_COLLECTION_PATH } from '../config/EntityCollectionPathMap';

const getSurveysNames = (search, offset = 0, limit = 100, showConnectSurveys = false) => {
  const params = {
    fields: { survey: 'name,id' },
    filter: { ...toSurveyListSearchFilter(search), ...(!showConnectSurveys && onlyCommonSurveysFilter) },
    page: { limit, offset },
  };

  return axios
    .get(buildApiV2Url(SURVEY_TYPE_COLLECTION_PATH, params), {
      headers: jsonApiHeaders,
    })
    .catch(generateApiError())
    .then(property('data'))
    .then(mapSurveyNamesListFromApiModel);
};

export default getSurveysNames;
